export enum CommunicationType {
  WiFi = 'wiFi',
  LTE = 'lte',
  Ethernet = 'ethernet',
}
